import React, { useContext, useEffect } from 'react';
import { ConfigContext } from '../../../contexts/ConfigContext';
import useWindowSize from '../../../hooks/useWindowSize';
import {useModuloControle} from '../../../contexts/ModuloControleContext';
import NavContent from './NavContent';
import CardAjuda from '../../../components/Ajuda/CardAjuda';
import { UPDATEDATAINI } from '../../../store/actions';

const Navigation = () => {
  const configContext = useContext(ConfigContext);
  const { dispatch, state } = configContext;
  const {
    bloquearMenu,
    menuResgate
  } = useModuloControle();


  const { layout, layoutType, navFixedLayout, collapseMenu, rtlLayout, boxLayout, subLayout, headerFixedLayout, headerBackColor, menuUsuario, moduloAtual } = state;
  const windowSize = useWindowSize();

  useEffect(() => {
    dispatch({ type: UPDATEDATAINI, updateDataIni: true });
  }, [dispatch]);

  const navigation = menuUsuario.length === 0 ? menuResgate : menuUsuario[1];

  const scroll = () => {
    if (navFixedLayout && !headerFixedLayout) {
      const el = document.querySelector('.pcoded-navbar.menupos-fixed');
      const scrollPosition = window.pageYOffset;
      if (scrollPosition > 60) {
        el.style.position = 'fixed';
        el.style.transition = 'none';
        el.style.marginTop = '0';
      } else {
        el.style.position = 'absolute';
        el.style.marginTop = '56px';
      }
    } else {
      document.querySelector('.pcoded-navbar')?.removeAttribute('style');
    }
  };

  let navClass = ['pcoded-navbar', layoutType];

  if (layout === 'horizontal') {
    navClass.push('theme-horizontal');
  } else {
    if (navFixedLayout) navClass.push('menupos-fixed');
    if (navFixedLayout && !headerFixedLayout) {
      window.addEventListener('scroll', scroll, true);
      window.scrollTo(0, 0);
    } else {
      window.removeEventListener('scroll', scroll, false);
    }
  }

  if (windowSize.width < 992 && collapseMenu) {
    navClass.push('mob-open');
  } else if (collapseMenu) {
    navClass.push('navbar-collapsed');
  }

  document.body.classList.toggle('gradient-able-dark', layoutType === 'dark');
  document.body.classList.toggle('gradient-able-rtl', rtlLayout);
  document.body.classList.toggle('container', boxLayout);
  document.body.classList.toggle('box-layout', boxLayout);

  const navBarClass = ['navbar-wrapper'];
  if (layout === 'horizontal' && subLayout === 'horizontal-2') {
    navBarClass.push('container');
  }

  let navContent = (
    <div className={navBarClass.join(' ')}>
      <NavContent navigation={navigation.items} />
    </div>
  );

  if (bloquearMenu.resgate) {
    navContent = (
     <CardAjuda />
    );
  }

  return (
    <nav className={navClass.join(' ')}>
      {navContent}
    </nav>
  );
};

export default Navigation;
